export const requireNonNull = <T>(obj: T | undefined): T => {
	if (!obj) {
		throw new Error('Object is not set');
	}
	return obj;
}
